import { Breadcrumb } from "client/CommonComponents"
import { GetStatusIcon } from "client/utils/IconsUtil"

const OrderDetailViewBreadcrumb = (props:any) => {
    return(
        <div className="clearfix breadCrumbBlock mb-2">
            {
                <div className='backButton mb-sm-2 mb-3' onClick={props.handleClickBack}>
                <span className="fa fa-chevron-left"></span>
                Back
                </div>
            }
            <div className="breadcrumbList">
            <Breadcrumb items={props?.breadcrumlist} maxDisplayedItems="5"  data-attribute="OrderDetailViewBreadcrumb_Default_Breadcrumb" />
            </div>
            <div className="float-right">
            <div className="pending">
                <img
                src={props?.iconReturn(props?.orderDetails?.orderStatus)}
                alt={GetStatusIcon(props?.orderDetails?.orderStatus)?.status}
                title={GetStatusIcon(props?.orderDetails?.orderStatus)?.status}
                className={GetStatusIcon(props?.orderDetails?.orderStatus)?.status === "Fleet Processing" ? "fleetprocessingicon me-2 iconMargin" : props?.orderDetails?.orderStatus === "Completed" ? 'completedicon statusIcon' : "me-2 iconMargin"}
                />
                <span className="pending-approval-text">
                {GetStatusIcon(props?.orderDetails?.orderStatus)?.status}
                </span>
            </div>
            </div>
        </div>
    )
}

export default OrderDetailViewBreadcrumb